import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/DisconnectTiktokAdAccount.graphql';
import { Mutation, MutationdisconnectTiktokAdAccountArgs } from '../../__generated__/globalTypes';

export const useDisconnectTiktokAdAccountMutation = (
  options?: MutationHookOptions<Mutation, MutationdisconnectTiktokAdAccountArgs>
) => {
  const [callDisconnectTiktokAdAccount, result] = useMutation<Mutation, MutationdisconnectTiktokAdAccountArgs>(
    MUTATION,
    options
  );

  return { callDisconnectTiktokAdAccount, ...result };
};

export type DisconnectTiktokAdAccountMutationFunction = Mutation['disconnectTiktokAdAccount'];
